import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import EmptyState from "@/components/EmptyState";
import { ClipboardCheck } from "lucide-react";

export default function Quizzes() {
    const [quizzes, setQuizzes] = useState([]);
    const [attempts, setAttempts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Promise.all([
            api.get("/quizzes").then((r) => r.data),
            api.get("/quiz-attempts/me").then((r) => r.data),
        ]).then(([q, a]) => { setQuizzes(q); setAttempts(a); }).finally(() => setLoading(false));
    }, []);

    const bestForQuiz = (qid) => {
        const list = attempts.filter((a) => a.quiz_id === qid);
        if (!list.length) return null;
        return list.reduce((m, a) => (a.score > m.score ? a : m), list[0]);
    };

    return (
        <div className="space-y-10" data-testid="quizzes-page">
            <div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-ink-400 font-mono mb-3">Assessments</div>
                <h1 className="font-editorial text-4xl md:text-5xl text-ink-900 leading-[1.05]">Quizzes.</h1>
                <p className="mt-3 text-base text-ink-500">Verify your understanding. Each module is gated by its quiz.</p>
            </div>

            {loading ? (
                <div className="text-sm text-ink-500" data-testid="quizzes-loading">Loading…</div>
            ) : quizzes.length === 0 ? (
                <EmptyState title="No quizzes yet" description="Quizzes will appear once your administrator creates them." icon={ClipboardCheck} testId="quizzes-empty" />
            ) : (
                <div className="bg-white border border-ink-300 divide-y divide-ink-200">
                    {quizzes.map((q) => {
                        const best = bestForQuiz(q.id);
                        return (
                            <div key={q.id} className="px-6 py-5 flex items-center justify-between gap-6 flex-wrap" data-testid={`quiz-row-${q.id}`}>
                                <div className="min-w-0">
                                    <div className="font-heading text-lg text-ink-900">{q.title}</div>
                                    {q.description && <div className="text-sm text-ink-500 mt-0.5 line-clamp-1">{q.description}</div>}
                                    <div className="mt-2 text-[11px] font-mono uppercase tracking-[0.15em] text-ink-400">
                                        Pass at {q.pass_threshold}%{best ? ` · Best ${best.score}% (${best.passed ? "passed" : "retry"})` : " · Not attempted"}
                                    </div>
                                </div>
                                <Link
                                    to={`/quizzes/${q.id}`}
                                    data-testid={`quiz-start-${q.id}`}
                                    className="bg-haevn-700 text-white px-5 py-2 rounded-sm text-sm hover:bg-haevn-900 transition-colors"
                                >
                                    {best ? "Retake" : "Begin"}
                                </Link>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
